import { render, staticRenderFns } from "./ExpressOrderTableUser.vue?vue&type=template&id=03c9c2a2&scoped=true"
import script from "./ExpressOrderTableUser.vue?vue&type=script&lang=js"
export * from "./ExpressOrderTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9c2a2",
  null
  
)

export default component.exports